export const FinalCTASection = ({ onCtaClick }) => {
  return (
    <section
      data-testid="final-cta-section"
      className="bg-[#0D1F17] py-6 md:py-12 px-5 md:px-8"
    >
      <div className="max-w-2xl mx-auto">
        <div
          className="card-forest flex flex-col gap-6"
          style={{ padding: 24 }}
        >
          <p className="microlabel text-center">Prochaine étape</p>

          <h2
            className="text-[#F5EFE3] text-center"
            style={{
              fontFamily: 'Inter, system-ui, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(26px, 6vw, 44px)',
              letterSpacing: '-0.02em',
              lineHeight: 1.1,
            }}
          >
            On se parle&nbsp;?{' '}
            <span
              className="font-serif-italic block sm:inline"
              style={{ color: '#F5EFE3', fontWeight: 500 }}
            >
              30&nbsp;minutes qui peuvent tout changer.
            </span>
          </h2>

          <div className="mt-1 flex flex-col" style={{
            borderTop: '1px solid rgba(245, 239, 227, 0.12)',
            borderBottom: '1px solid rgba(245, 239, 227, 0.12)',
          }}>
            {[
              { n: '01', t: 'Tu réponds à quelques questions pour qu\u2019on comprenne ta situation.' },
              { n: '02', t: 'Tu choisis un créneau de 30\u00A0minutes sur Google Meet.' },
              { n: '03', t: 'On analyse ton projet et on te dit si HDA est fait pour toi. Sans engagement.' },
            ].map((step, idx, arr) => (
              <div
                key={step.n}
                className="flex items-start gap-4 py-5"
                style={{
                  borderBottom:
                    idx < arr.length - 1
                      ? '1px solid rgba(245, 239, 227, 0.12)'
                      : 'none',
                }}
              >
                <span
                  className="font-serif shrink-0"
                  style={{
                    color: 'rgba(245, 239, 227, 0.45)',
                    fontSize: 20,
                    lineHeight: 1,
                    width: 28,
                  }}
                >
                  {step.n}
                </span>
                <p
                  className="text-[#F5EFE3]/72"
                  style={{ color: 'rgba(245, 239, 227, 0.72)', fontSize: 16, lineHeight: 1.5 }}
                >
                  {step.t}
                </p>
              </div>
            ))}
          </div>

          <button
            data-testid="final-cta-button"
            onClick={onCtaClick}
            className="btn-primary w-full"
          >
            Réserver mon appel stratégique
          </button>

          <p
            className="text-center"
            style={{ color: 'rgba(245, 239, 227, 0.45)', fontSize: 12 }}
          >
            30 minutes · Google Meet · Sans engagement
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
